/**
 * This file exists to minimise the size of the final file due to how GSAP handles it's exports, and reduce the change
 * of accidentally importing from all.js. If you import from 'gsap/all', you get a massive file with lots of unused
 * code.
 */

import {gsap, CSSPlugin} from 'gsap/all';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(CSSPlugin, ScrollToPlugin);

window._gsap = {
    gsap,
    CSSPlugin,
    ScrollToPlugin
};

export * from 'gsap/all';